<mat-dialog-content class="p-0">
  <div class="dialog">
    <p class="text-end">
      <span mat-button mat-dialog-close>

        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
          <path id="close-btn"
            d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
            transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
      </span>
    </p>
    <div class="suspend">
      <ng-container>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="160" height="160.375"
          viewBox="0 0 160 160.375">
          <defs>
            <clipPath id="clip-path">
              <circle id="circle" cx="80" cy="80" r="80" transform="translate(880 200)" fill="#fdeee7" />
            </clipPath>
          </defs>
          <g id="auction-ended-ic" transform="translate(-880 -200)">
            <circle id="circle-2" data-name="circle" cx="80" cy="80" r="80" transform="translate(880 200)"
              fill="#fdeee7" />
            <g id="Hammer" opacity="0.3" clip-path="url(#clip-path)">
              <path id="hammer-2" data-name="hammer"
                d="M2.871,122.163A10.719,10.719,0,0,1,3.4,107.031l50.7-47.38A13.784,13.784,0,0,1,54.877,45.8l-4.38-4.38A9.618,9.618,0,0,1,39.115,26.16L62.458,2.817A9.618,9.618,0,0,1,77.715,14.2l33.648,33.647A9.634,9.634,0,0,1,122.746,49.5l.04.041A9.665,9.665,0,0,1,122.75,63.1L99.4,86.448h0a9.621,9.621,0,0,1-15.26-11.385l-4.378-4.378a13.794,13.794,0,0,1-13.848.775L18.529,122.165l-.019.02-.042.044c-.067.07-.133.14-.2.207-.091.092-.179.176-.267.258a10.718,10.718,0,0,1-15.131-.53Zm4.269-11.126a5.227,5.227,0,1,0,7.126,7.648c.045-.042.088-.083.13-.126s.064-.066.1-.1l.038-.04,1.946-2.082L9.23,109.083Zm6.1-5.7,6.987,6.988,41.363-44.26-4.09-4.09ZM97.468,84.51h0ZM113.02,53.377h0L89.676,76.721a4.138,4.138,0,1,0,5.852,5.852l23.343-23.343a4.166,4.166,0,0,0,.011-5.84l-.026-.026a4.137,4.137,0,0,0-5.836.014ZM54.653,37.824l5.829,5.829.015.014L81.856,65.026c.026.025.052.051.077.077l5.806,5.806,19.468-19.468L74.122,18.355Zm21.1,28.849L58.887,49.807a8.285,8.285,0,0,0,.854,8.555q.056.068.108.139a8.4,8.4,0,0,0,.635.715l.014.014,5.836,5.836a8.312,8.312,0,0,0,.744.661q.054.039.106.082A8.288,8.288,0,0,0,75.753,66.673ZM66.333,6.692,42.99,30.035a4.138,4.138,0,0,0,5.851,5.852L72.185,12.543a4.138,4.138,0,1,0-5.852-5.851Z"
                transform="translate(875.858 230.721)" fill="#e9580e" stroke="rgba(0,0,0,0)" stroke-miterlimit="10"
                stroke-width="1" />
            </g>
            <g id="Base" opacity="0.3">
              <path id="base-2" data-name="base"
                d="M808.649,552.851H734.373a2.74,2.74,0,0,1-2.74-2.74v-5.535a10.972,10.972,0,0,1,10.959-10.959h.044v-2.794A10.972,10.972,0,0,1,753.6,519.864h35.831a10.972,10.972,0,0,1,10.959,10.959v2.794h.044a10.972,10.972,0,0,1,10.959,10.959v5.535A2.74,2.74,0,0,1,808.649,552.851Zm-71.536-5.48h68.8v-2.795a5.486,5.486,0,0,0-5.48-5.48H742.592a5.486,5.486,0,0,0-5.48,5.48Zm11-13.754h46.79v-2.794a5.486,5.486,0,0,0-5.48-5.48H753.6a5.486,5.486,0,0,0-5.48,5.48Z"
                transform="translate(228.612 -192.852)" fill="#f08a56" />
              <path id="base-3" data-name="base"
                d="M737.113,547.372h68.8v-2.795a5.486,5.486,0,0,0-5.48-5.48H742.592a5.486,5.486,0,0,0-5.48,5.48Z"
                transform="translate(228.612 -192.852)" fill="#fdeee7" />
              <path id="base-4" data-name="base"
                d="M748.116,533.618h46.79v-2.794a5.486,5.486,0,0,0-5.48-5.48H753.6a5.486,5.486,0,0,0-5.48,5.48Z"
                transform="translate(228.612 -192.852)" fill="#fdeee7" />
            </g>
            <path id="Subtraction_4" data-name="Subtraction 4"
              d="M759.744,14160.946H743.208a1.7,1.7,0,1,1,0-3.392h16.536a1.7,1.7,0,1,1,0,3.392Zm-16.532-12.313a1.72,1.72,0,0,1-1.482-.854,1.662,1.662,0,0,1-.171-1.279,1.683,1.683,0,0,1,.793-1.03l14.73-8.745a1.717,1.717,0,0,1,2.332.63,1.657,1.657,0,0,1,.171,1.279,1.691,1.691,0,0,1-.8,1.031l-14.73,8.74A1.633,1.633,0,0,1,743.212,14148.633Z"
              transform="translate(277.297 -13842.487)" fill="#f08a56" opacity="0.3" />
            <g id="warning" transform="translate(0 -7.937)">
              <path id="warning-2" data-name="warning"
                d="M10.868,75.367h63.2a8.391,8.391,0,0,0,7.26-12.59l-31.6-54.6a8.389,8.389,0,0,0-14.52,0l-31.6,54.6a8.391,8.391,0,0,0,7.26,12.59Z"
                transform="translate(877.531 292.944)" fill="#f53649" />
              <path id="warning-3" data-name="warning"
                d="M38.3,43.055a4.209,4.209,0,0,1-4.2-4.2V30.465a4.2,4.2,0,1,1,8.393,0v8.393A4.209,4.209,0,0,1,38.3,43.055Zm4.2,16.787H34.1V51.448H42.5Z"
                transform="translate(881.701 295.88)" fill="#fff" />
            </g>
          </g>
        </svg>

        <h4 class="title mt-4">{{'items-requests.End the auction' | translate }}?</h4>
        <div class="info-badge">
          {{'items-requests.The original time of the auction has not yet finished' | translate }}.
        </div>
        <div class="hint">
          {{'items-requests.In order to end this auction you must take one of the following decisions' | translate }}.
        </div>



        <div class="actions">
          <div>
            <button mat-button class="btn_fill mb-4" type="submit" (click)="endWithWinner()" [appLoading]="loading">
              {{'items-requests.End and sell item to the Highest Bidder' | translate }}.
            </button>
          </div>
          <div>
            <button mat-button class="btnLight_fill mb-4" (click)="endWithoutWinner()" [appLoading]="loading">{{'items-requests.End without winner' | translate }}</button>
          </div>
          <div>
            <button mat-button mat-dialog-close class="btn btn-blank " [appLoading]="loading">{{'actions.cancel' | translate}}</button>
          </div>
        </div>


      </ng-container>

    </div>
  </div>
</mat-dialog-content>